import { DropdownProps } from '@procore/core-react/dist/_typedoc/Dropdown/Dropdown.types.json';
import * as React from 'react';
export default {
  DropdownProps,
  React
};